import angular from 'angular';

declare var LtFramework: lt.Static;

export default abstract class BaseAccountController {

	protected $scope: ng.IScope;
	protected profile: lt.IProfile;

	private ssoId: string;

	constructor($scope: ng.IScope, profileValue?: lt.IProfile) {
		const profileStore = LtFramework.getStore('ProfileStore') as lt.IProfileStore;
		const profile = profileValue || profileStore.getInitialData();

		this.$scope = $scope;
		this.profile = profile;
		angular.merge(profileValue || {}, profile);

		// perform the initial load right now if the profile data is already available
		if (profile.initialized && profile.sso) {
			setTimeout(() => {
				$scope.$apply(() => {
					this.loadDataIfSsoChanged(profile);
					this.profileDataLoaded();
				});
			}, 0);
		} else if (profile.initialized) {
			// if the profile is initialized by there is no sso
			setTimeout(() => {
				$scope.$apply(() => {
					this.profileDataLoaded();
				});
			}, 0);
		} else {
			// reload our data if the user's profile data changes
			profileStore.listen((profileData) => {
				$scope.$apply(() => {
					this.profile = angular.merge(profileValue || {}, profileData);
					this.loadDataIfSsoChanged(profileData);
					this.profileDataLoaded();
				});
			});
		}
	}

	public dump(model: object): string {
		return JSON.stringify(model);
	}

	/**
	 * Override this method to run code that depends on a valid SSO ID existing.
	 */
	protected loadData(): void {
		throw new Error('This method is abstract');
	}

	/**
	 * Override this method to run code that depends on a valid memberDetails existing.
	 */
	protected profileDataLoaded(): void {
		throw new Error('This method is abstract');
	}

	private loadDataIfSsoChanged(profile: lt.IProfile): void {
		if (!this.ssoId || this.ssoId !== profile.sso) {
			this.ssoId = profile.sso;
			this.loadData();
		}
	}
}
